const GENERIC_MESSAGE =
  'Ocorreu um problema interno. Tente novamente mais tarde'

// Mensagem para toast de erro: mensagem do backend (400), da exceção lançada
// (ex.: resposta 200 com erro no corpo) ou genérica (erro de rede/servidor)
export const getErrorMessage = (error: any): string => {
  if (error?.response) {
    return error.response.status === 400
      ? error.response.data?.message || GENERIC_MESSAGE
      : GENERIC_MESSAGE
  }
  return error?.message || GENERIC_MESSAGE
}
